import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import ReactTable from 'react-table';
import moment from 'moment';
import { connect } from 'react-redux';
import { massUpdateColumns, massUpdateReceipt } from './actions';

class ModalReceive extends React.Component {
    constructor() {
        super();
        /* this.state = {
            massReceiptUpdates: [],
        }; */

        this.massUpdateColumns = massUpdateColumns.bind(this);
        this.massUpdateReceipt = massUpdateReceipt.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!prevProps.visible) && this.props.visible) {
            // After popup is shown
            const array = [];
            if (typeof this.props.receipts === 'object') {
                const selectedReceipts = this.props.receipts.filter(receipt => this.props.selectedReceipt.includes(receipt.Id));

                for (let a = 0; a < selectedReceipts.length; a++) {
                    array.push({
                        Given_Amount__c: selectedReceipts[a].Approved_Amount__c,
                        Date_Received__c: moment(),
                        Mode_of_Payment__c: 'Cash',
                        Cheque_Transaction_No__c: '',
                    });
                }

                // this.setState({ massReceiptUpdates: array });
                // this.props.updateMass(array);
            }
        } else if (prevProps.visible && (!this.props.visible)) {
            // After popup is hidden
            // this.setState({ massReceiptUpdates: [] });
            // this.props.updateMass([]);
        }
    }

    render() {
        const givenAmount = (
            <React.Fragment>
                <p className="labelFor">Given Amount</p>
                <input
                    value={this.props.formValue.Given_Amount__c || ''}
                    type="number"
                    min="0"
                    className="form-control"
                    onChange={e => this.props.onFormChanged(e.target.value, 'Given_Amount__c')}
                />
            </React.Fragment>
        );

        const paymentMode = (
            <React.Fragment>
                <p className="labelFor">Mode Of Payment</p>
                <select
                    className="form-control"
                    onChange={e => this.props.onFormChanged(e.target.value, 'Mode_of_Payment__c')}
                    value={this.props.formValue.Mode_of_Payment__c || ''}
                >
                    <option value="">-</option>
                    <option value="Cash">Cash</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Giro">Giro</option>
                </select>
            </React.Fragment>
        );

        const transactionNumber = (
            <React.Fragment>
                <p className="labelFor">Cheque or transaction no</p>
                <input
                    value={this.props.formValue.Mode_of_Payment__c === 'Cash' ? '' : (this.props.formValue.Cheque_Transaction_No__c || '')}
                    maxLength="20"
                    type="text"
                    className="form-control"
                    required={this.props.formValue.Mode_of_Payment__c !== 'Cash'}
                    disabled={this.props.formValue.Mode_of_Payment__c === 'Cash'}
                    onChange={e => this.props.onFormChanged(e.target.value, 'Cheque_Transaction_No__c')}
                />
            </React.Fragment>
        );

        const regularUpdateForm = (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                {givenAmount}
                <p className="labelFor">Date Received</p>
                <DatePicker
                    selected={this.props.formValue.Date_Received__c}
                    onChange={value => this.props.onFormChanged(value, 'Date_Received__c')}
                    dateFormat="DD/MM/YYYY"
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />
                {paymentMode}
                {transactionNumber}
            </div>
        );

        const massUpdateForm = (
            <ReactTable
                data={this.props.receipts.filter(receipt => this.props.selectedReceipt.includes(receipt.Id))}
                columns={this.massUpdateColumns()}
                defaultPageSize={5}
            />
        );

        return (
            <div className="modal modal-backdrop" data-backdrop="static" tabIndex="-1" role="dialog" style={{ display: this.props.visible ? 'block' : 'none' }}>
                <div className="modal-dialog" style={this.props.isMassUpdate ? { minWidth: '90%' } : {}} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.close}><span aria-hidden="true">&times;</span></button>
                            <h4 className="modal-title">Receive Update</h4>
                        </div>
                        <div className="modal-body">
                            <form
                                id="modal-receive"
                                // onSubmit={this.props.isMassUpdate ? this.massUpdateReceipt : this.props.save}
                                onSubmit={this.props.save}
                            >
                                <p style={{ textAlign: 'center' }}>
                                    {this.props.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                                </p>
                                {this.props.isMassUpdate ? massUpdateForm : regularUpdateForm}
                                <div className="clearfix" />
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.props.close}>Cancel</button>
                            <button type="submit" className="btn btn-success" form="modal-receive">Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ModalReceive.propTypes = {
    save: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    visible: PropTypes.bool,
    onFormChanged: PropTypes.func.isRequired,
    updateMass: PropTypes.func.isRequired,
    formValue: PropTypes.object,
    loading: PropTypes.bool,
    isMassUpdate: PropTypes.bool,
    receipts: PropTypes.array,
    selectedReceipt: PropTypes.array,
    massReceiptUpdates: PropTypes.array,
};

ModalReceive.defaultProps = {
    visible: false,
    formValue: {},
    loading: false,
    receipts: [],
};

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});

export default connect(mapStateToProps)(ModalReceive);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Receipt/ModalReceive.js
// module id = 417
// module chunks = 0